import React, { useEffect } from 'react';
import { map } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { show } from 'redux-modal';
import { getAllLots } from '../../../actions/parkingLotActions';
import RollBox from '../../Administration/RollBox';
import { getAllSpots } from '../../../actions/parkingSpotActions';
import { Button } from '../../utils/forms/Button';

function ParkingLotsPage() {
  const lots = useSelector((state) => state.lots);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllSpots())
      .then(() => {
        dispatch(getAllLots());
      })
  }, []); 


  return (
    <>
      <div className="mb2">
        <Button color="secondary" icon="fas fa-plus-circle" size="sm" onClick={() => dispatch(show('newParkingLotModal'))}>Přidat parkoviště </Button>
      </div>
      {map(lots, (lot) => (
        <RollBox key={lot.id} id={lot.id} /> 
      ))}
    </>
  );
}

export default ParkingLotsPage;
